import { render } from "./DashboardApp.vue?vue&type=template&id=7d7e4e3d&scoped=true"
import script from "./DashboardApp.vue?vue&type=script&lang=js"
export * from "./DashboardApp.vue?vue&type=script&lang=js"

import "./DashboardApp.vue?vue&type=style&index=0&id=7d7e4e3d&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7e4e3d"]])

export default __exports__